var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaxingGibbousMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76837e-07 25C0.00439582 33.4465 2.76633 41.6549 7.85647 48.3493C11.6334 49.7948 15.6982 50.3018 19.709 49.8274C23.7198 49.3531 27.5594 47.9113 30.9051 45.6233C34.2508 43.3354 37.0047 40.2681 38.9354 36.6793C40.8661 33.0905 41.9171 29.0852 42 25C41.9171 20.9148 40.8661 16.9095 38.9354 13.3207C37.0047 9.73194 34.2508 6.66464 30.9051 4.37667C27.5594 2.0887 23.7198 0.646934 19.709 0.172583C15.6982 -0.301768 11.6334 0.205158 7.85647 1.65074C2.76633 8.34511 0.00439582 16.5535 4.76837e-07 25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaxingGibbousMoonIcon);
export default __webpack_public_path__ + "static/media/WaxingGibbousMoonIcon.24fd73de243e74d1a0c5afc943825fc4.svg";
export { ForwardRef as ReactComponent };